import { WebSocketService } from '@widgets/shared/services/webSocketService/webSocketService'
import type { MessengerWebSocketEventMap } from '@widgets/messenger/types/api/websocket'

export class MessengerWebSocketService extends WebSocketService<MessengerWebSocketEventMap> {}

export default new MessengerWebSocketService()
